import React from 'react';
import { Alert, Box, Typography } from '@mui/material';
import { FormDataConsumer, useTranslate } from 'react-admin';
import { computeSiteValidationIssues } from './siteValidation';

export const SiteValidationBanner: React.FC = () => {
    const translate = useTranslate();

    return (
        <FormDataConsumer>
            {({ formData }) => {
                const { hardErrors, softWarnings } = computeSiteValidationIssues(formData, translate);
                if (hardErrors.length === 0 && softWarnings.length === 0) return null;
                return (
                    <Box sx={{ mb: 2 }}>
                        {hardErrors.length > 0 && (
                            <Alert severity="error" sx={{ mb: softWarnings.length > 0 ? 1.5 : 0 }}>
                                <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
                                    {translate('resources.sites.validation.hardErrorsTitle', {
                                        _: 'Required fields missing',
                                    })}
                                </Typography>
                                <Box component="ul" sx={{ m: 0, pl: 2 }}>
                                    {hardErrors.map((msg, i) => (
                                        <li key={i}>
                                            <Typography variant="body2">{msg}</Typography>
                                        </li>
                                    ))}
                                </Box>
                            </Alert>
                        )}
                        {softWarnings.length > 0 && (
                            <Alert severity="warning">
                                <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
                                    {translate('resources.sites.validation.softWarningsTitle', {
                                        _: 'Recommended',
                                    })}
                                </Typography>
                                <Box component="ul" sx={{ m: 0, pl: 2 }}>
                                    {softWarnings.map((msg, i) => (
                                        <li key={i}>
                                            <Typography variant="body2">{msg}</Typography>
                                        </li>
                                    ))}
                                </Box>
                            </Alert>
                        )}
                    </Box>
                );
            }}
        </FormDataConsumer>
    );
};
